export default "__VITE_ASSET___U1WMl9H__"